<template>
  <div class="wrapper">
    <el-card class="box-card first" body-style="padding:5px;" header-style="padding:5px;">
      <div slot="header" class="clearfix">
        <h5>{{ title }}</h5>
        <el-input v-model="filterText" size="mini" placeholder="输入关键字进行过滤" />
      </div>
      <div v-if="initData.length" style="height: 210px;">
        <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
        <vue-easy-tree
          ref="tree"
          :data="initData"
          height="190px"
          show-checkbox
          :node-key="nodeKey"
          :default-checked-keys="response"
          :filter-node-method="filterNode"
          :props="defaultProps"
          :render-content="renderContent"
          @check="handleCheckChange"
        />
      </div>
      <div v-else class="item_box">
        <el-empty :image-size="50" description="请先输入搜索" />
      </div>
    </el-card>
    <el-card class="box-card check">
      <div slot="header" class="clearfix">
        <h5>{{ title }}</h5>
        <div>
          <span v-if="maxCount">可选 {{ maxCount }},</span>
          <span>已选 {{ check_item.length }}</span>
          <el-button class="clean_all" type="text" @click="cleanCheckItem">清空</el-button>
        </div>
      </div>

      <RecycleScroller
        v-slot="{ item }"
        class="item_box"
        :items="check_item"
        :item-size="30"
        key-field="value"
      >
        <div class="text item">
          <div class="item">
            <span class="text">
              {{ output_data_map[item] || item }}
            </span>
            <i class="el-icon-close" @click="handleClose(item)" />
          </div>
        </div>
      </RecycleScroller>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'Shuttle',
  model: {
    prop: 'response',
    event: 'change',
  },
  props: {
    title: { type: String, default: '' },
    response: { type: Array, default: () => ([]) },
    nodeKey: { type: String, default: 'id' },
    outputData: {
      type: Array,
      default: () => ([]),
    },
    showTooltip: { type: Boolean, default: false },
    filterNodeMethod: {
      type: Function,
      default: null,
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'label',
        };
      },
    },
    initData: {
      type: Array,
      default: () => ([]),
    },
    /** 最大选择数量，0为不限制 */
    maxCount: {
      type: Number,
      default: () => 0,
    },
    /** 是否多选 - 预留扩展字段 */
    multiple: {
      type: Boolean,
      default: true,
    },
    /** 是否严格的遵守父子节点不互相关联 */
    checkStrictly: {
      type: Boolean,
      default: true,
    },
    /** 是否返回由该节点所在的各级菜单的值所组成的数组 - 预留扩展字段 */
    emitPath: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      checkAll: false,
      // 扁平化数据
      output_data: [],
      output_data_map: Object.create(null),
      filterText: '',
      // 右侧已选参数
      check_item: [],
      new_response: this.response,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    initData() {
      this.forceUpdateProps();
    },
    /** 监听选中值 */
    response() {
      this.forceUpdateProps();
    },
  },
  mounted() {
    this.forceUpdateProps();
  },
  methods: {
    /** 刷新初始数据 */
    forceUpdateProps() {
      this.$nextTick(() => setTimeout(this.initProps, 0));
    },
    /** 初始化props */
    initProps() {
      // 重置选中数据
      this.output_data = [];
      this.output_data_map = Object.create(null);
      this.resetData(this.initData);
      // 有列表数据传进来
      if (this.initData.length) {
        this.checkResHas();
      }
      // 没有列表数据时用传进来的列表数据
      if (!this.initData.length) {
        this.output_data = this.outputData;
        this.outputData.forEach(item => {
          this.output_data_map[item[this.nodeKey]] = item[this.defaultProps.label];
        });
        this.setOutputData(this.response);
      }
    },
    /**
     * 重置数据
     * @param  list  传入数据源
    */
    resetData(list) {
      list.forEach(item => {
        this.output_data.push(item);
        this.output_data_map[item[this.nodeKey]] = item[this.defaultProps.label];
        if (item.children && item.children.length !== 0) {
          this.resetData(item.children);
        }
      });
    },

    // 检测传进来的值是否存在于列表中
    checkResHas(){
      if (this.outputData?.length){
        this.output_data.push(...this.outputData);
        this.outputData.forEach(item => {
          this.output_data_map[item[this.nodeKey]] = item[this.defaultProps.label];
        });
      }
      // 按左侧树的扁平顺序整理已选项，避免首次操作时从接口顺序跳变。
      const responseKeys = new Set(this.response);
      const have_arr = this.output_data
        .map(item => item[this.nodeKey])
        .filter(item => responseKeys.has(item));
      this.setOutputData(have_arr);
    },

    /**
     * 格式化初始数据成tree数据
     * @param  arr  传入数据源
    */
    setOutputData(arr) {
      this.check_item = arr;
    },

    // 筛选
    filterNode(value, data) {
      if (this.filterNodeMethod) {
        return this.filterNodeMethod(value, data);
      }
      if (!value) {
        return true;
      }
      return data[this.defaultProps.label].indexOf(value) !== -1;
    },

    // 树选择
    handleCheckChange() {
      const nodes = this.resetOutputData(
        this.getSimpleCheckedNodes(this.$refs.tree.store)
      );
      if (this.maxCount > 0 && nodes.length > this.maxCount) {
        this.$message.warning('选择数量超出限制');
        this.$refs.tree.setCheckedKeys(this.check_item);
      } else {
        // 按左侧树节点顺序同步右侧列表，保持旧逻辑的显示顺序。
        this.check_item = nodes;
        this.setTop(nodes);
      }
    },

    // 重置进出口的参数
    resetOutputData(list) {
      const _list = [];
      list.forEach(item => {
        _list.push(item[this.nodeKey]);
      });
      return _list;
    },

    // 清除所有选中项
    cleanCheckItem(item) {
      // 控制tree
      this.checkAll = false;
      this.$refs.tree.setCheckedNodes([]);
      this.check_item = [];
      this.setTop([]);
    },

    // 已选池-单项删除
    handleClose(val) {
      // 控制tree
      this.check_item.splice(this.check_item.indexOf(val), 1);
      this.$refs.tree.setChecked(val, false);
      this.setTop(this.check_item);
    },

    /**
     * 获取当前已选择的节点
     * @param {Object} store 节点 - 通常为根节点
     * @param {boolean} is_check_all 是否为全选
     * @returns {Object[]} 已选中的节点
     */
    getSimpleCheckedNodes(store, is_check_all = false) {
      const checkedNodes = [];
      const traverse = (node) => {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(child => {
          if (
            /**
             * child.visible用于判断节点是否处于显示状态 - 过滤时，不符合过滤条件的节点会处于child.visible = true
             * 全选 - 对数据进行过滤后进行全选，全选数据会 覆盖 当前已选中数据
             * 单选 - 对数据进行过滤后进行单选，单选数据会 添加至 当前已选中数据
             */
            child.checked &&
            (!is_check_all || is_check_all && child.visible)
          ) {
            if (!this.checkStrictly && child.childNodes.length) {
              child.childNodes.forEach(child_nodes_item => {
                if (child_nodes_item.childNodes.length) {
                  traverse(child_nodes_item);
                } else {
                  checkedNodes.push(child_nodes_item.data);
                }
              });
            } else {
              checkedNodes.push(child.data);
            }
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);
      return checkedNodes;
    },

    /**
     * 渲染多选框内容
     * @param h 渲染函数
     * @param node 当前节点对象
     * @param data 当前节点数据
    */
    renderContent(h, { node, data }){
      if (this.showTooltip){
        return (
          <el-tooltip open-delay={500} effect='dark' content={'覆盖人数：' + data.num} placement='top'>
            <span class='custom-tree-node'>
              <span>{node.label}</span>
            </span>
          </el-tooltip>

        );
      } else {
        return (
          <span class='custom-tree-node'>
            <span>{node.label}</span>
          </span>
        );
      }
    },

    // 全选
    checkAllChange() {
      if (this.checkAll) {
        this.$refs.tree.setCheckedAll(true);
      } else {
        this.$refs.tree.setCheckedAll(false);
      }
      const nodes = this.resetOutputData(
        this.getSimpleCheckedNodes(this.$refs.tree.store, true)
      );
      if (this.maxCount > 0 && nodes.length > this.maxCount) {
        this.$message.warning('选择数量超出限制');
        this.$refs.tree.setCheckedKeys(this.check_item);
        this.$nextTick(() => {
          this.checkAll = false;
        });
      } else {
        this.check_item = nodes;
        this.setTop(nodes);
      }
    },

    // 改变爸爸
    setTop(data) {
      this.new_response = data;
      this.$emit('change', this.new_response);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  height: 307px;
}
// 深度选择器 >>> 因为scss无法解析>>> 所有用/deep/转换符代替
.box-card /deep/ .el-card__header {
  padding: 5px;
  background: #eff2f6 !important;
  h5 {
    margin: 5px;
    height: 20px;
    line-height: 20px;
    border-bottom: 1px solid #fff;
  }
  div {
    span {
      font-size: 12px;
      font-weight: 600;
      padding-left: 5px;
    }
    .clean_all {
      position: relative;
      float: right;
    }
  }
}
.clearfix > .el-input {
  width: 100% !important;
}
.box-card {
  margin-top: 5px;
  min-width: 200px;
  max-width: 300px;
  height: 300px;
  float: left;
  margin-right: 5px;

  .item_box {
    height: 210px;
    overflow: auto;
    .item {
      width: 100%;
      border-radius: 5px;
      background: #edf1f5;
      height: 25px;
      line-height: 25px;
      font-size: 12px;
      padding: 0 5px;
      margin-bottom: 5px;

      .text {
        float: left;
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .el-icon-close {
        float: right;
        font-size: 15px;
        border-radius: 50%;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        float: right;
      }
      .el-icon-close:hover {
        background: #7a7a7a;
        color: #eff2f6;
      }
    }
  }
}
</style>
